import { useEffect, useRef, type ReactNode } from 'react'

interface Props {
  title: string
  children: ReactNode
  onClose: () => void
  /**
   * Một nút nhỏ đứng cạnh nút đóng.
   *
   * Dành cho tấm trượt dài phải cuộn: nút chốt việc nằm ở đáy thì mỗi lần sửa một dòng
   * lại phải cuộn hết xuống mới bấm được. Dùng dè — hàng này chỉ cao 48px.
   */
  right?: ReactNode
}

/**
 * Tấm trượt từ dưới lên. Mọi hộp thoại trong app đều dùng cái này để thao tác
 * quen tay — và để nút bấm luôn nằm ở nửa dưới màn hình, trong tầm ngón cái.
 */
export function Sheet({ title, children, onClose, right }: Props) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', onKey)
    ref.current?.focus()
    return () => document.removeEventListener('keydown', onKey)
  }, [onClose])

  return (
    <div className="overlay" onPointerDown={(e) => e.target === e.currentTarget && onClose()}>
      <div className="sheet" role="dialog" aria-modal="true" aria-label={title} tabIndex={-1} ref={ref}>
        <div className="sheet-head">
          <h2>{title}</h2>
          {right}
          <button type="button" className="icon-btn" onClick={onClose} aria-label="Đóng">
            ✕
          </button>
        </div>
        <div className="sheet-body">{children}</div>
      </div>
    </div>
  )
}
